import { render, staticRenderFns } from "./NewDiagnosticCategoryModal.vue?vue&type=template&id=5c3f7a6e"
import script from "./NewDiagnosticCategoryModal.vue?vue&type=script&lang=js"
export * from "./NewDiagnosticCategoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports